import styled from 'styled-components'
import { up } from 'styled-breakpoints'
import Title from '../../../components/Title'
import Container from '../../../components/Container'
import WysiwygOutput from '../../../components/WysiwygOutput'
import NextLink from '../../../components/Next/NextLink'

export default function Buy() {
  return (
    <StyledBuy>
      <Container>
        <StyledBuyInner>
          <StyledBuyTitle>
            <Title level={1}>Где купить?</Title>
          </StyledBuyTitle>

          <StyledBuyGrid>
            <StyledBuyCell>
              <NextLink href="https://fishfood.by">
                <StyledBuyLink target="_blank">
                  <StyledBuyLinkTitle>Для физических лиц</StyledBuyLinkTitle>
                  <StyledBuyLinkImg>
                    <img
                      width={150}
                      height={82}
                      src={require('../../../assets/images/Frame.svg')}
                      alt="rebox"
                    />
                    <div className="text">
                      <WysiwygOutput>
                        <p>
                          Гастромаркет "FISH&FOOD". Доставка продуктов, рыбы, морепродуктов и деликатесов. Магазин в Минске на Маяковского, 14.
                        </p>
                      </WysiwygOutput>
                    </div>
                  </StyledBuyLinkImg>
                </StyledBuyLink>
              </NextLink>
            </StyledBuyCell>
          </StyledBuyGrid>
        </StyledBuyInner>
      </Container>
    </StyledBuy>
  )
}

Buy.defaultProps = {}

Buy.propTypes = {}

const StyledBuyLinkTitle = styled.div`
  margin-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
  font-family: 'Montserrat';

  ${up('md')} {
    margin-bottom: 30px;
  }
  ${up('xl')} {
    margin-bottom: 40px;
    font-size: 22px;
    line-height: 130%;
  }
`
const StyledBuyInner = styled.div`
  max-width: 900px;
`
const StyledBuyTitle = styled.div`
  font-weight: 500;
  margin-bottom: 40px;
`

const StyledBuyLinkImg = styled.div`
  text-align: center;
`
const StyledBuyLink = styled.a`
  display: inline-block;
  text-decoration: none;
  color: ${(props) => props.theme.colorPrimary};
  font-weight: 500;
  transition: color ${(props) => props.theme.transitionTime};

  &:hover {
    color: ${(props) => props.theme.colorSecondary};
  }
`

const StyledBuyCell = styled.div`
  padding-bottom: 50px;

  ${up('md')} {
    padding-left: 30px;
    padding-right: 30px;
  }

  ${up('lg')} {
    padding-left: 55px;
    padding-right: 55px;
  }

  &:nth-child(2) {
    img {
      ${up('md')} {
        width: 220px;
      }
    }
  }

  .text {
    text-align: left;
    margin-top: 40px;
  }
`
const StyledBuyGrid = styled.div`
  margin-bottom: -50px;

  ${up('md')} {
    display: flex;
    flex-wrap: nowrap;
    margin-left: -30px;
    margin-right: -30px;
  }

  ${up('lg')} {
    margin-left: -55px;
    margin-right: -55px;
  }
`
const StyledBuyText = styled.div`
  margin-bottom: 40px;

  ${up('md')} {
    margin-bottom: 60px;
  }
  ${up('xl')} {
    margin-bottom: 80px;
  }
`

const StyledBuy = styled.div`
  padding-top: 103px;
  padding-bottom: 48px;
  overflow: hidden;

  ${up('md')} {
    padding-bottom: 60px;
  }

  ${up('lg')} {
    padding-top: 116px;
  }

  ${up('xl')} {
    padding-top: 182px;
    padding-bottom: 144px;
  }
`
